import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import CommonBooking from '../Common/common_booking';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { Link, useLocation } from 'react-router-dom';
import { generatePath } from 'react-router';

const BookingDetail = (props) => {
  const [bookData, setBookData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [shopName, setShopName] = useState(null);
  const [talkName, setTalkName] = useState(null);
  const [text, setText] = useState(null);
  const [loglist, setLoglist] = useState(null);

  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  //book_idを取得
  const bookId = queryParams.get('bk');



  const refreshLog = useCallback(async () => {
    //ログを設定する
    const jwt = localStorage.getItem('jwt'); var param = {
      site_id: props.siteId,
      book_id: bookId
    }
    const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/search/book`, param, { headers: { Authorization: `Bearer ${jwt}` } });
    const logs = result.data.sort((a, b) => new Date(a.ins_date) - new Date(b.ins_date));
    setLoglist(logs);
  }, [props.siteId, bookId]);

  const refreshBook = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    var params = {
      "site_id": props.siteId,
      "book_id": Number(bookId),
    }
    try {
      //予約内容取得
      const booking = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/booking/search_detail_one/`,
        params,
        { headers: { Authorization: `Bearer ${jwt}` } }
      );
      setBookData(booking.data)

      const params_customer = {
        site_id: props.siteId,
        operator: "and",
        where: [
          { site_id: props.siteId },
        ]
      }
      //顧客情報取得
      // 予約の認証 auth
      const customer = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/search/`, params_customer, { headers: { Authorization: `Bearer ${jwt}` } });
      setCustomerData(customer.data.filter(d => Number(d.customer_id) === Number(booking.data.customer_id))[0])
      //ログ情報取得
      refreshLog();
      //店舗
      const shoplist = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
      //予約の目的一覧取得
      const talklist = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/talk_category/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] })).data;
      setShopName(shoplist.filter(d => Number(d.shop_id) === Number(booking.data.t_booking_detail.shop_id))[0].shop_name)
      if (booking.data.t_booking_detail.talk_id) {
        setTalkName(talklist.filter(d => Number(d.talk_id) === Number(booking.data.t_booking_detail.talk_id))[0].talk)
      } else {
        setTalkName("")
      }
    } catch (err) {
      console.log("エラー", err);
    }
  }, [props.siteId, bookId, refreshLog]);

  const renderButton = (data, status, statusName, additionalStatus = []) => {
    additionalStatus.push(status);
    return (
      <button type="button"
        disabled={lockData}
        // 条件次第で色が変わる
        className={`btn ${additionalStatus.includes(data.status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.status].includes(status) || (data.status === "TREG" && status === "FIN") ? 'btn-active' : 'btn-secondary')} mx-1`}
        onClick={() => handleStatusButtonClick(data.book_id, status)}>
        {(data.status === "TREG" && status === "FIN") ? "予約承認" : additionalStatus.includes(data.status) ? statusName : constClass.STATUS_NAME_BTN[status]}
      </button>
    )
  }

  const handleStatusButtonClick = async (book_id, status) => {
    var book = bookData;
    if (book.status === status) {
      // 同じボタンを押したときはひとつ前のステータスに戻す
      status = constClass.STATUS.REG;
    }
    if (status === constClass.STATUS.FIN && book.status === constClass.STATUS.TREG && !window.confirm(`受付番号[${book.receipt_num}]を予約承認済にします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.CCL && !window.confirm(`受付番号[${book.receipt_num}]をキャンセルします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.FIN && book.status !== constClass.STATUS.TREG && !window.confirm(`受付番号[${book.receipt_num}]を来店済にします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.REG && !window.confirm(`受付番号[${book.receipt_num}]のステータスを予約に戻します。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.FIN && book.status === constClass.STATUS.TREG) {
      status = constClass.STATUS.REG;
    }
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: props.match.params.siteId,
      status,
      upd_name: props.user.userId
    };
    try {
      setLockData(true);
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/backyard_status/${book_id}`, params, { headers: { Authorization: `Bearer ${jwt}` } });

      var sendtext = "";
      if (status === constClass.STATUS.REG && book.status === constClass.STATUS.TREG) {
        sendtext = "受付番号：" + book.receipt_num + "\n予約承認済になりました";
      }
      if (status === constClass.STATUS.CCL) {
        sendtext = "受付番号：" + book.receipt_num + "\n予約がキャンセルされました";
      }
      if (status === constClass.STATUS.FIN && !(book.status === constClass.STATUS.TREG)) {
        sendtext = "受付番号：" + book.receipt_num + "\n予約が来店済になりました";
      }
      if (status === constClass.STATUS.REG && !(book.status === constClass.STATUS.TREG)) {
        sendtext = "受付番号：" + book.receipt_num + "\nステータスを予約に戻します";
      }
      console.log("bookData", bookData);
      const send_params = {
        site_id: props.match.params.siteId,
        user_id: props.user.userId,
        text: sendtext,
        book_id: book_id,
        shop_id: props.user.shopId,
        old_status: book.status,
      }
      //メッセージを送信
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/send`, send_params, { headers: { Authorization: `Bearer ${jwt}` } });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      addToast('ステータスを更新しました。', { appearance: 'success', autoDismiss: true });
      await refreshBook();
      setLockData(false);
    }
  }
  const changeTalktext = (event) => {
    const target = event.target.value;
    setText(target)
  }

  const submit = async () => {
    if (!window.confirm(`送信してよろしいですか？`)) {
      return;
    }
    try {
      const jwt = localStorage.getItem('jwt');
      var param = {
        site_id: props.siteId,
        user_id: props.user.userId,
        text: text,
        book_id: bookId,
      }
      const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/send/linemessage`, param, { headers: { Authorization: `Bearer ${jwt}` } });
      if (result.status === 200) {
        addToast('送信が完了いたしました', { appearance: 'success', autoDismiss: true });
        setText('')
        refreshLog();
        // ここでログ履歴を再度取得する処理を追加する
      } else {
        addToast('送信が失敗しました 1', { appearance: 'error', autoDismiss: true });
      }
    } catch {
      addToast('送信が失敗しました 2', { appearance: 'error', autoDismiss: true });
    }
  }

  useEffect(() => {
    refreshBook();
  }, [refreshBook]);

  return (bookData && customerData && shopName && (talkName || talkName === "") &&
    <div>
      <div className="row">
        <div className="col-6">
          <div className='px-2 p-1'><h5>予約情報</h5></div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>受付番号</div>
            <div className='col-9'>{bookData.receipt_num}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>支所</div>
            <div className='col-9'>{shopName}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>ご予約日</div>
            <div className='col-9'>{bookData.book_date}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>ご予約時間帯</div>
            <div className='col-9'>{CommonBooking.strTotime(bookData.t_booking_detail.start_time)}～{CommonBooking.strTotime(bookData.t_booking_detail.end_time)}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>予約の目的</div>
            <div className='col-9'>{talkName}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>予約目的詳細</div>
            <div className='col-9' style={{ overflowWrap: 'anywhere' }}>{bookData.t_booking_detail.talktext}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>担当職員</div>
            <div className='col-9'>{bookData.t_booking_detail.staff_name}</div>
          </div>
        </div>

        <div className="col-6">
          <div className='px-2 p-1'><h5>会員情報</h5></div>
          <div className='row px-3-env p-2'>
            <div className='col-3'>会員番号</div>
            <div className='px-2 col-9'>{customerData.card_id}</div>
          </div>
          <div className='row px-3-env p-2'>
            <div className='col-3'>お名前</div>
            <div className='col-9'>{bookData.customer_name}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>カナ</div>
            <div className='col-9'>{bookData.customer_kana}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>生年月日</div>
            {customerData.birthdayy && customerData.birthdaym && customerData.birthdayd &&
              <div className='col-9'>{customerData.birthdayy}年{customerData.birthdaym}月{customerData.birthdayd}日</div>}
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>性別</div>
            <div className='col-9'>{bookData.customer_gender ? constClass.CUSTOMER_GENDER_NAME[bookData.customer_gender] : ""}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>郵便番号</div>
            <div className='col-9'>{customerData.customer_address_number}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>住所</div>
            <div className='col-9'>{customerData.customer_address1} {customerData.customer_address2} {customerData.customer_address3}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>電話番号</div>
            <div className='col-9'>{customerData.customer_phone}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>携帯電話番号</div>
            <div className='col-9'>{customerData.customer_mobilephone}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>ご希望の連絡先</div>
            <div className='col-9'>{bookData.t_booking_detail.connect_means ? constClass.CUSTOMER_PHONE_NAME[bookData.t_booking_detail.connect_means] : ""}</div>
          </div>
          <div className='row px-3-env p-1'>
            <div className='col-3'>平日連絡可能時間</div>
            <div className='col-9'>{(bookData.t_booking_detail.customer_before_time && bookData.t_booking_detail.customer_after_time) ? bookData.t_booking_detail.customer_before_time + "時～" + bookData.t_booking_detail.customer_after_time + "時" : ""}</div>
          </div>
        </div>
      </div>
      <div className='row px-3-env p-1'>
        <div className='col-3'>処理</div>
        <div className='col-9'>
          {renderButton(bookData, constClass.STATUS.FIN, constClass.STATUS_NAME_PKG.FIN)}
          {renderButton(bookData, constClass.STATUS.CCL, constClass.STATUS_NAME_PKG.CCL)}
        </div>
      </div>
      <div className='col-12'>
        <hr />
      </div>

      <div className="px-3-env p-1">
        <Link className="btn btn-secondary text-white" to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}BookingInput?bk=${bookId}`}>予約変更</Link>
      </div>

      {bookData.line_id !== 'unknown_user' &&
        <div className="p-3">
          <div>LINEメッセージ</div>
          <textarea className="form-control" rows={5} onChange={e => changeTalktext(e)} value=
            {text || ''} />
          <button
            disabled={text === null || text === ""}
            className={`btn btn-active col-1 mt-2 mb-2`}
            onClick={submit}
          >
            送信
          </button>
          {/* ログテーブルを作成する */}
          <table className="table table-bbooked table-striped" height="1">
            <thead>
              <tr>
                <th className="text-left align-middle like-button px-3" style={{ width: '1%', whiteSpace: 'nowrap' }}>
                  送信日時
                </th>
                <th className="text-left align-middle like-button px-3">
                  送信履歴
                </th>
              </tr>
            </thead>
            <tbody>
              {loglist.length <= 0 && <tr><td className="text-center align-middle p-3" colSpan={10}>条件に一致するログがありません</td></tr>}
              {loglist.map((data, idx) => (
                <tr key={idx}>
                  {/* 登録日時 */}
                  <td className="text-left align-middle p-1 px-3" style={{whiteSpace: 'nowrap' }}>
                    {new Date(data.ins_date).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/\//g, '/').replace(/, /, ' ')}
                  </td>
                  {/* テキスト */}
                  <td className="text-left align-middle p-1 px-3">
                    {data.text}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>}
    </div>
  )
}

export default BookingDetail;